module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Tomb-Raider.c37c46e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Tomb-Raider.jpg
// module id = jGoA
// module chunks = 0